import { createFileRoute } from '@tanstack/react-router';
import { prefetch } from '@/app/prefetch';
import { AuditsPage } from '@/features/audits/list/audits-page';
import { parseAuditSearch } from '@/features/audits/list/audit-search';

export const Route = createFileRoute('/_app/w/$workspaceId/audits/')({
    staticData: { crumbs: [{ label: 'shell.audits' }] },
    validateSearch: parseAuditSearch,
    loaderDeps: ({ search }) => ({ search }),
    loader: ({ context, deps }) => prefetch.audits(context.queryClient, context.workspaceScope, deps.search),
    component: function AuditsRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        const search = Route.useSearch();
        return <AuditsPage organizationId={organizationId} workspaceId={workspaceId} search={search} />;
    },
});
